import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RequestingParams, SendRequest } from "../../type";
import { get } from "../../util/APIService";
import { HttpStatus } from "../../enums/httpStatus";

export const getAllSendRequests = createAsyncThunk(
  "feedback/requests/send",
  async (requestParams: RequestingParams, storeActions) => {
    const url = `api/v1/user/feedback-requests/send` + requestParams.requestParams;
    const response: any = await get(url, storeActions);

    if (response.status === HttpStatus.OK) {
      return {
        status: HttpStatus.OK,
        data: await response.json(),
      };
    } else {
      return {
        status: response.status,
        text: await response.text(),
      };
    }
  }
);

const allSendRequestsSlice = createSlice({
  name: "allRequestsSend",
  initialState: {
    status: null as number | null,
    text: null as string | null,
    data: null as Array<SendRequest> | null,
    loading: false as boolean,
  },
  reducers: {
    clearData: (state) => {
      state.status = null;
      state.loading = false;
      state.text = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllSendRequests.fulfilled, (state, action) => {
      state.status = action.payload.status;
      if (action.payload.data !== undefined) {
        state.data = action.payload.data;
        state.text = null;
      } else if (action.payload.text !== undefined) {
        state.data = null;
        state.text = action.payload.text;
      }
      state.loading = false;
    });
    builder.addCase(getAllSendRequests.pending, (state) => {
      state.loading = true;
      state.status = null;
      state.text = null;
      state.data = null;
    });
    builder.addCase(getAllSendRequests.rejected, (state) => {
      state.status = 503;
      state.text = null;
      state.data = null;
      state.loading = false;
    });
  },
});

export const { clearData } = allSendRequestsSlice.actions;

export default allSendRequestsSlice;
